import { useState, useEffect } from 'react';
import { useIsClient } from '@alfa-bank/site-helpers-common/browser/use-is-client';

/**
 * Хук для получения и отслеживания значения якоря в URL
 */
export const useAnchorValue = (): string | null => {
    const isClient = useIsClient();
    const [anchorValue, setAnchorValue] = useState<string | null>(null);

    useEffect(() => {
        if (!isClient) return;

        const updateAnchor = () => {
            setAnchorValue(window.location.hash);
        };

        updateAnchor();

        window.addEventListener('hashchange', updateAnchor);

        return () => {
            window.removeEventListener('hashchange', updateAnchor);
        };
    }, [isClient]);

    return anchorValue;
};
